module.exports = __webpack_public_path__ + "static/media/share-v3.8dd078f5.svg";